const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @vendor
const { Promise } = require('es6-promise');
const moment = require('moment');
const trim = require('lodash/string/trim');
// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { calculateContract } = require('utilities/ibanHelper');
// @ utilities
const { tagFiocPersonalInfoSuccess } = require('utilities/taggingInfo/fiocTags');
const download = require('downloadjs');
const BrowserUtils = require('utilities/browserUtils');
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const { generateAccountId } = require('utilities/APIParsingHelper');
const { getAccountsByCountries } = require('utilities/accountTypeHelper');
// @ actions
const gdprConsentsActions = require('actions/gdprConsents');
const signaturePatternActions = require('actions/signaturePattern');
const { outdateAndResetReducers } = require('actions/projectWideActions');
const accountIntervenersActions = require('actions/getAccountInterveners');
const actions = require('./hireJuniorAccount');
const { getFiocStatus } = require('./fiocDocumentation');
const openYoungGetProfilesActions = require('./openYoungProfiles');
const openYoungGetProfileDetailsActions = require('./openYoungProfileDetails');
const notification = require('actions/notifications');
const { requestPinSet } = require('actions/hireCardPinSet');
const accountAddDocumentationActions = require('actions/accountAddDocumentation');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const registerDocumentsActions = require('actions/registerDocuments');
const { sendPrecontractualDocumentMail } = require('actions/precontractualDocumentsMailer');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    CAMPAIGN_PRICING_CHANNEL,
    CHECKING_ACCOUNT_STANDARD,
    CHECKING_ACCOUNT_SUBTYPE,
    CHECKING_ACCOUNT_TYPE,
    PAYROLL_ACCOUNT_STANDARD,
    PAYROLL_ACCOUNT_SUBTYPE,
    PAYROLL_ACCOUNT_TYPE,
} = require('constants/index');
const {
    CHECKING_ACCOUNT_PRODUCT_ALIAS,
    OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
    PAYROLL_ACCOUNT_PRODUCT_ALIAS,
    PAYROLL_UPGRADE_ACCOUNT_PRODUCT_ALIAS,
} = require('constants/hiringProductInformation');
const { PAYROLL_ACCOUNT_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo')
const {
    HIRE_ACCOUNTS_ADD_DOCUMENTATION,
} = require('constants/flagBasedFeatures');
const DateHelper = require('../utilities/dateHelper');

const setRenewalOrTransferToken = token => ({
    type: actionTypes.CONTRACT_SET_RENEWAL_OR_TRANSFER_TOKEN,
    payload: {
        token
    }
});

const setMaxImportAmount = amount => ({
    type: actionTypes.CONTRACT_SET_MAX_IMPORT_AMOUNT,
    payload: {
        maxAmount: amount
    }
});

const setImpositionAmount = amount => ({
    type: actionTypes.CONTRACT_SET_IMPOSITION_AMOUNT,
    payload: amount,
})

const setRenewalDepositId = id => ({
    type: actionTypes.CONTRACT_SET_RENEWAL_DEPOSIT_ID,
    payload: {
        id
    }
});

const setRenewalAccountBlocked = isBlocked => ({
    type: actionTypes.CONTRACT_SET_RENEWAL_ACCOUNT_BLOCKED,
    payload: {
        isBlocked
    }
});

const updateAccounts = accounts => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_ACCOUNTS,
    payload: {
        accounts
    }
});

const depositInterestFetching = () => ({
    type: actionTypes.CONTRACT_DEPOSITS_INTEREST_FETCHING,
})

const depositInterestSuccess = ({ calculatedInterest }) => ({
    type: actionTypes.CONTRACT_DEPOSITS_INTEREST_SUCCESS,
    payload: {
        calculatedInterest
    }
})

const depositInterestFailure = (error) => ({
    type: actionTypes.CONTRACT_DEPOSITS_INTEREST_FAILURE,
    payload: {
        error
    }
})

const isCurrentAccount = (type, subtype) =>
    type === '300' &&
    (subtype === '800' || subtype === '801' || subtype === '803' || subtype === '805');

const isTitular = type => type === 'TITULAR' || type === 'COTITULAR';

const getCurrentAccounts = accounts =>
    accounts.filter(account => {
        const {
            cnuevo: { producto },
            criterios: { c1: { subtipoproducto } },
            descIntervenciones: { nomTipInterv }
        } = account;
        return isCurrentAccount(producto, subtipoproducto) && isTitular(nomTipInterv.trim());
    });

const requestAccounts = () => dispatch =>
    new Promise(() => {
        const requestData = {
            query: {
                listaSolicitada: 'CUENTAS_C'
            }
        };
        APIGet(dispatch, apiURLBuilder.getURL('globalPosition'), requestData).then(
            response =>
                dispatch(
                    updateAccounts(
                        getCurrentAccounts(
                            response.datosSalidaCuentas.cuentas.map((account, index) =>
                                Object.assign(account, response.datosSalidaCodIban.datosIban[index])
                            )
                        )
                    )
                ),
            error => error.description
        );
    });

function isServiceCalled(isCalled) {
    return {
        type: actionTypes.CONTRACT_METHOD_IS_SERVICE_CALLED,
        payload: {
            isCalled
        }
    };
}

function hire() {
    return {
        type: actionTypes.CONTRACT_METHOD_HIRE,
        payload: {}
    };
}

function setContract(contract_name, contract_type, contract_hiring_data) {
    return {
        type: actionTypes.CONTRACT_METHOD_SET_CONTRACT,
        payload: {
            contract_hiring_data,
            contract_name,
            contract_type,
        }
    };
}

const setPayrollAccountPromoCode = (promoCode) => {
    return {
        type: actionTypes.SET_PAYROLL_ACCOUNT_PROMO_CODE,
        payload: {
            code: promoCode
        }
    };
}

function updateCardDetails(card_details) {
    return {
        type: actionTypes.CONTRACT_METHOD_UPDATE_CARD_DETAILS,
        payload: {
            card_details
        }
    };
}

function setDepositPolled(deposit) {
    return {
        type: actionTypes.CONTRACT_METHOD_SET_DEPOSIT_POLLED,
        payload: {
            deposit
        }
    };
}

function updateDepositProduct(deposit_product) {
    return {
        type: actionTypes.CONTRACT_METHOD_UPDATE_DEPOSIT_PRODUCT,
        payload: {
            deposit_product
        }
    };
}

function toggleInfoModal() {
    return {
        type: actionTypes.CONTRACT_METHOD_TOGGLE_INFO_MODAL,
    }
}

function updateConfirmationCheckboxes(confirmationCheckboxes) {
    return {
        type: actionTypes.CONTRACT_METHOD_UPDATE_CONFIRMATION_CHECKBOXES,
        payload: {
            confirmationCheckboxes
        }
    };
}

function updateConditionDocumentConfirmation(conditionDocumentConfirmation) {
    return {
        type: actionTypes.CONTRACT_METHOD_UPDATE_CONDITIONS_CONFIRMATION,
        payload: {
            conditionDocumentConfirmation
        }
    };
}

function reset() {
    return {
        type: actionTypes.CONTRACT_METHOD_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.CONTRACT_METHOD_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function validateUIStep(step) {
    return {
        type: actionTypes.CONTRACT_METHOD_VALIDATE_STEP,
        payload: {
            step
        }
    };
}

//requireValidation: [steps]
//validationFunction: actionName
const validateStep = step => (dispatch, getState) => {
    dispatch(validateUIStep(step));
    const immContracts = getState().contracts;
    const requireValidation = immContracts.get('requireValidation');
    if (
        requireValidation &&
        requireValidation.indexOf(step) !== -1 &&
        immContracts.get('isValidStep')
    ) {
        const validationFunction = immContracts.get('validationFunction');
        dispatch(actions[validationFunction]());
    }
};

function setWillCancel(willCancel) {
    return {
        type: actionTypes.CONTRACT_METHOD_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function setInProgress() {
    return {
        type: actionTypes.CONTRACT_METHOD_IN_PROGRESS
    };
}

function toNextStep(step) {
    return {
        type: actionTypes.CONTRACT_METHOD_NEXT_STEP,
        payload: {
            step
        }
    };
}

function closeModal(id) {
    return {
        type: actionTypes.CONTRACT_METHOD_CLOSE_MODAL,
        payload: {
            id
        }
    };
}

//Intervener manage
function setIntervenerType(index, type, changeTypeByIntervenerCode) {
    return {
        type: actionTypes.CONTRACT_METHOD_SET_ACCOUNT_INTERVENER_TYPE,
        payload: {
            index,
            type,
            changeTypeByIntervenerCode
        }
    };
}

function addIntervener() {
    return {
        type: actionTypes.CONTRACT_METHOD_ADD_INTERVENER
    };
}

function addSimpleIntervener(names, type, documentNumber) {
    return {
        type: actionTypes.CONTRACT_METHOD_ADD_SIMPLE_INTERVENER,
        payload: {
            names: names,
            documentNumber: documentNumber,
            type: type
        }
    };
}

function updateSimpleIntervener(names, documentNumber) {
    return {
        type: actionTypes.CONTRACT_METHOD_UPDATE_SIMPLE_INTERVENER,
        payload: {
            names: names,
            documentNumber: documentNumber,
        }
    };
}

function removeIntervener(index, originalInterveners) {
    return {
        type: actionTypes.CONTRACT_METHOD_REMOVE_INTERVENER,
        payload: {
            index,
            originalInterveners
        }
    };
}

function clearInterveners() {
    return {
        type: actionTypes.CONTRACT_METHOD_CLEAR_INTERVENERS
    };
}

function restoreDefaultInterveners(originalInterveners) {
    return {
        type: actionTypes.CONTRACT_METHOD_RESTORE_DEFAULT_INTERVENERS,
        payload: {
            originalInterveners
        }
    };
}

const postChange = () => (dispatch, getState) => {
    const callback = (/*dispatch*/) => {
        //dispatch(successChange());
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const hireContractSuccess = (response, type) => {
    return {
        type: actionTypes.HIRE_CONTRACT_SUCCESS,
        payload: {
            response,
            type
        }
    };
};

const hireContractNewAccountSuccess = (response, callback) => {
    callback();

    return {
        type: actionTypes.HIRE_ACCOUNT_SUCCESS,
        payload: {
            response
        }
    };
};

const hireContractFailure = response => ({
    type: actionTypes.HIRE_CONTRACT_FAILURE,
    payload: {
        response
    }
});

const contractGenericFetching = () => ({
    type: actionTypes.CONTRACT_GENERIC_FETCHING
});

const contractGenericLoading = () => ({
    type: actionTypes.CONTRACT_GENERIC_LOADING
});

const getTramitationExpedient = iban => dispatch => {
    const expedientNumber = iban.substring(4);
    const requestData = {
        query: {
            limitOnlyLogged: true,
        }
    };

    return APIGet({
        dispatch,
        params: requestData,
        url: apiURLBuilder.getURL('tramitationExpedient', { expedientNumber }),
    })
};

const getTramitationExpedientSuccess = response => ({
    type: actionTypes.HIRE_ACCOUNT_GET_TRAMITATION_EXPEDIENT_SUCCESS,
    payload: {
        response,
    }
});

const getTramitationExpedientError = response => ({
    type: actionTypes.HIRE_ACCOUNT_GET_TRAMITATION_EXPEDIENT_ERROR,
    payload: {
        response,
    }
});

const setPinSuccess = response => ({
    type: actionTypes.HIRE_ACCOUNT_SET_PIN_SUCCESS,
    payload: {
        response,
    }
});

const setPinError = response => ({
    type: actionTypes.HIRE_ACCOUNT_SET_PIN_ERROR,
    payload: {
        response,
    }
});

const setPrecontractualDocumentUrl = response => ({
    type: actionTypes.SET_PRECONTRACTUAL_DOCUMENT_URL,
    payload: {
        response,
    }
});

const getPrecontractualDocumentURLOrIDRequest = () => ({
    type: actionTypes.GET_PRECONTRACTUAL_DOCUMENT_URL_REQUEST,
});

const getPrecontractualsDocumentURLFailure  = () => ({
    type: actionTypes.GET_PRECONTRACTUAL_DOCUMENT_URL_FAILURE,
})

const setPrecontractualDocumentId = response => ({
    type: actionTypes.SET_PRECONTRACTUAL_DOCUMENT_ID,
    payload: {
        response,
    }
});

const getPrecontractualsDocumentIdFailure = () => ({
    type: actionTypes.GET_PRECONTRACTUAL_DOCUMENT_ID_FAILURE,
})

const postPin = (iban) => (dispatch, getState) => {
    const contract = iban.substring(iban.length - 7);
    const product = iban.substring(14, iban.length - 7);
    const currentCard = getState().hireCardImageSelector.get('selectedImageId');
    const immProfile = getState().profile;
    const personCode = immProfile.getIn(['codigoPersona', 'f']);
    const personType = immProfile.getIn(['codigoPersona', 'type']);

    return dispatch(requestPinSet(
        contract,
        product,
        currentCard,
        personCode,
        personType,
    ))
        .then(response => {
            dispatch(setPinSuccess(response));
        })
        .catch(error => {
            dispatch(setPinError(error));
        });
};

const setHireContractNewAccount = (dispatch, getState, data, callback) => {
    const requestData = {
        query: data
    };

    dispatch(contractGenericLoading());

    return APIPost({ dispatch, endpoint: 'createNewAccount', params: requestData })
        .then(createNewAccountResponse => {
            const immContracts = getState().contracts;
            const originCountry = getState().profile.get('originCountry');
            const contractName = immContracts.get('name_contract');
            const contractType = immContracts.get('contract_type');
            const operationProcessId = getState().contractualPolling.get('operationProcessId');
            let contractHiringData = {};

            const isCheckingAccount = contractName === 'checking-account'
            if (isCheckingAccount) {//Adding properties for passport logic
                contractHiringData['passportProductId'] = CHECKING_ACCOUNT_PRODUCT_ALIAS;
            } else {
                contractHiringData = immContracts.get('hiring_data_contract').toJS();
            }

            let cardImage = findElementbyId(immContracts.get('card_details'), 'card_image');
            let termsAndCondHiringData = [contractHiringData];

            if (!!cardImage) {
                termsAndCondHiringData.push(
                    {
                        passportProductId: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,//Checking and payroll hiring always links a debit card
                    }
                );
            }

            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData, operationProcessId));

            if (['checking-account', 'payroll-account'].includes(contractName)) {
                const iban = createNewAccountResponse.numeroCuenta;
                const hireStatus = createNewAccountResponse.msg;
                const immFlagBasedFeatures = getState().flagBasedFeatures;
                const noHolders = !findElementbyId(immContracts.get('card_details'), 'holders').get(0);
                const pinCountryFlags = immFlagBasedFeatures.get('not_allowed_hire_passport_pin_countries');
                const isAddDocumentationEnabled = noHolders && immFlagBasedFeatures.get(HIRE_ACCOUNTS_ADD_DOCUMENTATION);

                const operationProcessId = getState().contractualPolling.get('operationProcessId');
                const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');
                const contractNumber = createNewAccountResponse.numeroCuenta

                //This function is used to force success in Promise.all besides one of the endpoint fails
                //https://stackoverflow.com/questions/31424561/wait-until-all-es6-promises-complete-even-rejected-promises
                const reflect = promise => promise.then(value => ({ value, status: 'fulfilled' }),
                    error => ({ error, status: 'rejected' }));

                let tramitationExpedientPromise;
                let pinPromise;
                let promisesArray = [];
                let isPinEnabled = false;

                if (immFlagBasedFeatures.get('hire-accounts-pin-required-enabled') &&
                    !pinCountryFlags.find(country => country === originCountry) && !__CONTACT_CENTER__) {
                    isPinEnabled = true;
                }

                if (hireStatus === '2') {
                    if (isAddDocumentationEnabled) {
                        tramitationExpedientPromise = dispatch(getTramitationExpedient(iban));
                        let accountTypeAndSubtype;
                        if (contractName === 'payroll-account') {
                            accountTypeAndSubtype = PAYROLL_ACCOUNT_TYPE + PAYROLL_ACCOUNT_SUBTYPE;
                        } else {
                            accountTypeAndSubtype = CHECKING_ACCOUNT_TYPE + CHECKING_ACCOUNT_SUBTYPE;
                        }
                        tramitationExpedientPromise.then(response => {
                            const accountInfo = {
                                accountId: generateAccountId(iban),
                                accountNumber: iban,
                                alias: getAccountsByCountries(originCountry, accountTypeAndSubtype),
                                expedientNumber: iban.substring(4),
                                hasOneHolder: noHolders,
                                subtype: contractName,
                            }
                            dispatch(getTramitationExpedientSuccess(response));
                            dispatch(accountAddDocumentationActions.setAccountInfo(accountInfo));
                        });
                        tramitationExpedientPromise.catch(error => {
                            dispatch(getTramitationExpedientError(error));
                        });

                        promisesArray.push(tramitationExpedientPromise);
                    }

                    if (isPinEnabled) {
                        pinPromise = dispatch(postPin(iban));
                        promisesArray.push(pinPromise);
                    }
                    //If promisesArray is empty jumps directly to then
                    Promise.all(promisesArray.map(reflect))
                        .then(() => {
                            dispatch(outdateAndResetReducers());
                            dispatch(hireContractNewAccountSuccess(createNewAccountResponse, callback));
                            if (preContractualOperationProcessId) {
                                const registerDocumentsData = {
                                    query: {
                                        processes: [
                                            {
                                                processRelation: "PRECONTRACTUAL",
                                                operationProcessId: preContractualOperationProcessId
                                            },
                                            {
                                                processRelation: "CONTRACTUAL",
                                                operationProcessId: operationProcessId
                                            }
                                        ],
                                        productAlias: contractName === 'payroll-account' 
                                        ? PAYROLL_ACCOUNT_PRODUCT_ALIAS 
                                        : CHECKING_ACCOUNT_PRODUCT_ALIAS,
                                        contract: contractNumber,
                                    }
                                }
                                dispatch(registerDocumentsActions.registerDocuments(registerDocumentsData))
                            }
                        });
                } else if (hireStatus === '98' || hireStatus === '99') {
                    if (isAddDocumentationEnabled) {
                        dispatch(getTramitationExpedientError());
                    }

                    if (isPinEnabled) {
                        pinPromise = dispatch(postPin(iban));
                        promisesArray.push(pinPromise);
                    }
                    //If promisesArray is empty jumps directly to then
                    Promise.all(promisesArray.map(reflect))
                        .then(() => {
                            dispatch(outdateAndResetReducers());
                            dispatch(hireContractNewAccountSuccess(createNewAccountResponse, callback));
                        });
                } else {
                    dispatch(hireContractFailure(createNewAccountResponse.body || createNewAccountResponse));
                }
            } else {
                dispatch(outdateAndResetReducers());
                return dispatch(hireContractNewAccountSuccess(createNewAccountResponse, callback));
            }
        })
        .catch(response => {
            if (!!response.error) {
                if ((response.error.status === 504 || !!response.exception && response.exception.status === 504)){
                    response.error.timeoutError = true;
                    dispatch(hireContractFailure(response))
                }
                else {
                    dispatch(hireContractFailure(response.body || response))
                };
            }
            else {
                throw response;
            }
        });
};

const hireContractNewAccount = (data, intervenersData) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        data.onlineInput.firma = { dataToken };
        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setHireContractNewAccount(dispatch, getState, data, intervenersData))
            .catch(response => {
                if (!!response.error) {
                    setHireContractNewAccount(dispatch, data, intervenersData);
                }
                else {
                    throw response;
                }
            });
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const contractInformationFetching = () => ({
    type: actionTypes.CONTRACT_METHOD_GET_CONTRACT_INFORMATION_FETCHING
});

const contractInformationSucess = information => ({
    type: actionTypes.CONTRACT_METHOD_GET_CONTRACT_INFORMATION,
    payload: {
        information
    }
});

const contractInformationFailure = error => ({
    type: actionTypes.CONTRACT_METHOD_GET_CONTRACT_INFORMATION_FAILURE,
    payload: {
        error
    }
});

const getContractInformation = contract_ID => (dispatch, getState) => {
    const isAlreadyFetching = getState().contracts.get('isFetchingStep1');

    if (isAlreadyFetching) return;

    const language = getLanguage().toUpperCase();

    return new Promise(() => {
        dispatch(contractInformationFetching());
        APIGet(
            dispatch,
            `${apiURLBuilder.getURL('campaignEngine')}/default/${language}/${contract_ID}/1`
        )
            .then(response => dispatch(contractInformationSucess(response[0].body.value)))
            .catch(response => dispatch(contractInformationFailure(response.error)));
    });
};

const getContractInformationWithPricing = location => (dispatch, getState) => {
    const isAlreadyFetching = getState().contracts.get('isFetchingStep1');

    if (isAlreadyFetching) return;

    const data = {
        query: {
            lang: getLanguage().toUpperCase(),
            location: location,
            type: CAMPAIGN_PRICING_CHANNEL
        }
    }

    return new Promise(() => {
        dispatch(contractInformationFetching());
        APIPost(
            dispatch,
            apiURLBuilder.getURL('campaignWithPricing'),
            data
        )
            .then(response => {
                const htmlBody = response.nodes && response.nodes[0] && response.nodes[0].body && response.nodes[0].body[0];
                dispatch(contractInformationSucess(htmlBody && htmlBody.value));
            })
            .catch(response => {
                if (response.error) {
                    dispatch(contractInformationFailure(response.error));
                } else {
                    throw response;
                }
            });
    });
};

const professionCnaeSucess = items => ({
    type: actionTypes.GET_PROFESSION_CNAE,
    items
});

const professionCnaeIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNAE_IS_FETCHING
});

const getProfessionCnae = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().contracts.get('professionCnaeIsFeching');

    if (isAlreadyFetching) return;

    return new Promise(() => {
        dispatch(professionCnaeIsFetching());
        APIGet(dispatch, apiURLBuilder.getURL('getProfessionCnae')).then(
            response => dispatch(professionCnaeSucess(response.items)),
            error => error.description
        );
    });
};

const professionCnoSucess = items => ({
    type: actionTypes.GET_PROFESSION_CNO,
    items
});

const professionCnoIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNO_IS_FETCHING
});

const professionCnoPrivateSucess = items => ({
    type: actionTypes.GET_PROFESSION_CNO_PRIVATE,
    items
});

const professionCnoPrivateIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNO_PRIVATE_IS_FETCHING
});

const getProfessionCno = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().contracts.get('professionCnoIsFeching');
    const requestData = {
        query: {
            language: getLanguage()
        }
    };

    if (isAlreadyFetching) return;

    return new Promise(() => {
        dispatch(professionCnoIsFetching());
        APIGet(dispatch, apiURLBuilder.getURL('getProfessionCnoPublic'), requestData).then(
            response => dispatch(professionCnoSucess(response.items)),
            error => error.description
        );
    });
};

const getprofessionCnoPrivate = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().contracts.get('professionCnoProvateIsFetching');
    const requestData = {
        query: {
            language: getLanguage()
        }
    };

    if (isAlreadyFetching) {
        return
    }

    return new Promise(() => {
        dispatch(professionCnoPrivateIsFetching());
        APIGet(dispatch, apiURLBuilder.getURL('getProfessionCnoPrivate'), requestData).then(
            response => dispatch(professionCnoPrivateSucess(response.items)),
            error => error.description
        );
    });
}

const loadState = state => ({
    type: actionTypes.CONTRACT_METHOD_LOAD_STATE,
    payload: state
});

const requestAccountsSpecialInProgress = () => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_ACCOUNTS_IN_PROGRESS
});

const requestIntervenersInProgress = () => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_INTERVENERS_IN_PROGRESS
});

const requestAccountsSpecialSuccess = (response, accounts) => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_ACCOUNTS_SPECIAL,
    payload: {
        response,
        accounts
    }
});

const requestReferenceStandardFailure = error => ({
    type: actionTypes.CONTRACT_METHOD_FETCH_REFERENCE_STANDARD_FAILURE,
    payload: {
        error
    }
});

const requestReferenceStandardSuccess = response => ({
    type: actionTypes.CONTRACT_METHOD_FETCH_REFERENCE_STANDARD_SUCCESS,
    payload: {
        codigodeestandar: response.estandarReferencia
    }
});

const requestReferenceStandardInProgress = () => ({
    type: actionTypes.CONTRACT_METHOD_FETCH_REFERENCE_STANDARD_IN_PROGRESS
});

const requestIntervenersSpecialSuccess = inteveners => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_INTERVENERS_SPECIAL,
    payload: {
        inteveners
    }
});

const requestIntervenersSpecialFailure = error => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_INTERVENERS_SPECIAL_FAILURE,
    payload: {
        error
    }
});

const requestAccountsSpecialFailure = error => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_ACCOUNTS_SPECIAL_FAILURE,
    payload: {
        error
    }
});

const requestIntervenersSpecial = (immAccount, callback) => dispatch => {
    const requestData = {
        query: {
            producto: immAccount.get('product'),
            numeroContrato: immAccount.get('contractNumber')
        }
    };

    dispatch(requestIntervenersInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL('hiringInterveners'), requestData)
        .then(response => {
            callback && callback(immAccount, response.dato);
            dispatch(requestIntervenersSpecialSuccess(response.dato));
        })
        .catch(response => {
            if (response.error) {
                dispatch(requestIntervenersSpecialFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const requestAccountsSpecial = () => (dispatch, getState) => {
    dispatch(requestAccountsSpecialInProgress());
    const requestData = {
        query: {}
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hiringsAccounts'), requestData)
        .then(response => dispatch(requestAccountsSpecialSuccess(response, getState().accounts)))
        .catch(response => {
            if (response.error) {
                dispatch(requestAccountsSpecialFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const requestReferenceStandard = params => dispatch => {
    dispatch(requestReferenceStandardInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('pasiveHireReferenceStandard'), { query: params })
        .then(response => dispatch(requestReferenceStandardSuccess(response)))
        .catch(response => {
            if (response.error) {
                dispatch(requestReferenceStandardFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const changeIntervenerRelationship = (index, relationship) => ({
    type: actionTypes.CONTRACT_METHOD_UPDATE_INTERVENER_RELATIONSHIP,
    payload: {
        index,
        relationship
    }
});

const excludeIntervener = index => ({
    type: actionTypes.CONTRACT_METHOD_EXCLUDE_INTERVENER,
    payload: {
        index
    }
});

const deleteAdditionalCountry = countries => ({
    type: actionTypes.CONTRACT_METHOD_DELETE_ADDITIONAL_TAX_COUNTRY,
    payload: {
        countries
    }
});

const setCardImage = cardImage => ({
    type: actionTypes.CONTRACT_METHOD_SET_CARD_IMAGE,
    payload: {
        cardImage
    }
});

const requestUpgradeToPayrollAccount = (dispatch, data, getState) => {
    const requestData = {
        query: data.serviceParams
    };
    const immContracts = getState().contracts;
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];
    const operationProcessId = getState().contractualPolling.get('operationProcessId');
    const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');
    dispatch(contractGenericFetching());

    return APIPost(dispatch, apiURLBuilder.getURL('upgradeToPayrollAccount'), requestData)
        .then(response => {
            const { producto, numeroContrato } = data.accountNumberParams;
            response.accountNumber = calculateContract(producto + numeroContrato);
            dispatch(hireContractSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData, operationProcessId));

            if (preContractualOperationProcessId) {
                const registerDocumentsData = {
                    query: {
                        processes: [
                            {
                                processRelation: "PRECONTRACTUAL",
                                operationProcessId: preContractualOperationProcessId
                            },
                            {
                                processRelation: "CONTRACTUAL",
                                operationProcessId: operationProcessId
                            }
                        ],
                        productAlias: PAYROLL_UPGRADE_ACCOUNT_PRODUCT_ALIAS,
                        contract: response.accountNumber,
                    }
                }
                dispatch(registerDocumentsActions.registerDocuments(registerDocumentsData))
            }
        })
        .catch(response => {
            const originCountry = getState().profile.get('originCountry');
            if (response) {
                if (originCountry === 'ES' && ((!!response.error && response.error.status === 504) || (!!response.exception && response.exception.status === 504) || (!!response.body && response.body.error === "Connection Error"))){
                    response.error.timeoutError = true;
                    dispatch(hireContractFailure(response))
                }
                dispatch(hireContractFailure(response.body));
            } else {
                throw response;
            }
        });
};

const upgradeToPayrollAccount = params => (dispatch, getState) => {
    const {
        accountNumber,
        contractNumber,
        product,
        promotionalCode,
        subtipo,
        tipo
    } = params;

    const callback = (dispatch, getState, dataToken) => {
        const data = {
            serviceParams: {
                codigoPromocion: promotionalCode,
                firma: {
                    dataToken
                },
                numeroCuenta: accountNumber,
                referencia: {
                    estandar: CHECKING_ACCOUNT_STANDARD,
                    subtipo,
                    tipo
                }
            },
            accountNumberParams: {
                producto: product,
                numeroContrato: contractNumber
            }
        };
        requestUpgradeToPayrollAccount(dispatch, data, getState);
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const requestValidatePromotionalCodeInProgress = () => ({
    type: actionTypes.CONTRACT_METHOD_VALIDATE_PROMOTIONAL_CODE_IN_PROGRESS
});

const requestValidatePromotionalCodeFailure = (error, showPromoCodeOnFailure) => ({
    type: actionTypes.CONTRACT_METHOD_VALIDATE_PROMOTIONAL_CODE_FAILURE,
    payload: {
        error,
        showPromoCodeOnFailure
    }
});

const requestValidatePromotionalCodeSuccess = response => ({
    type: actionTypes.CONTRACT_METHOD_VALIDATE_PROMOTIONAL_CODE_SUCCESS,
    payload: {
        response
    }
});

const promotionalCodeSetDirty = () => ({
    type: actionTypes.CONTRACT_METHOD_VALIDATE_PROMOTIONAL_CODE_SET_DIRTY
});

const isPromotionExpired = response => {
    let promotionState = false;
    if (response.promotionalCode) {
        const endPromotionDate = moment(response.promotionalCode.finish).add(1, 'd');
        promotionState = moment().isAfter(endPromotionDate);
    }

    return promotionState;
};

const requestValidatePromotionalCodeComplete = (response, showPromoCodeOnFailure) => {
    let action;
    if (response.status === 'Error' || isPromotionExpired(response) || !response.promotionalCode.url) {
        let customErrorMessage;

        if (response.promotionalCode && !response.promotionalCode.url) {
            customErrorMessage = 'Error';
        } else {
            customErrorMessage = isPromotionExpired(response) ? 'Expired' : 'Error';
        }

        customErrorMessage = formatText(`promotions-inputErrorMessagePromotion${customErrorMessage}`);
        action = requestValidatePromotionalCodeFailure(customErrorMessage, showPromoCodeOnFailure);
    } else {
        action = requestValidatePromotionalCodeSuccess(response);
    }

    return action;
};

const requestValidatePromotionalCode = (promotionalcode, showPromoCodeOnFailure) => (dispatch, getState) => {
    const precontractualMailProductInfo = {
        codigoPromocion: promotionalcode,
        productName: PAYROLL_ACCOUNT_PRODUCT_NAME,
        producto: PAYROLL_ACCOUNT_TYPE,
        standard: PAYROLL_ACCOUNT_STANDARD,
        subproducto: PAYROLL_ACCOUNT_SUBTYPE,
    };
    const isUpgradeToPayrollAccount = getState().contracts.get('name_contract') === 'upgrade-to-payroll-account';

    let forceV2PrecontractualDocumentMailEndpoint = false;

    if (!isUpgradeToPayrollAccount) {
        precontractualMailProductInfo.productsRelated = [{
            productAlias: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
        }];
    } else {
        forceV2PrecontractualDocumentMailEndpoint = true;
    }

    dispatch(requestValidatePromotionalCodeInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('validatePromotionalCode', { code: promotionalcode }))
        .then(
            response => {
                dispatch(requestValidatePromotionalCodeComplete(response, showPromoCodeOnFailure));
                if (response.status === 'OK' && !isPromotionExpired(response)) {
                    dispatch(sendPrecontractualDocumentMail(precontractualMailProductInfo, true, forceV2PrecontractualDocumentMailEndpoint));
                }
            })
        .catch(response => {
            if (response.error) {
                const serviceErrorMsg = formatText('promotions-inputErrorMessagePromotionServiceError');
                dispatch(requestValidatePromotionalCodeFailure(serviceErrorMsg, showPromoCodeOnFailure));
            } else {
                throw response;
            }
        });
};

const cancelPromotionalCode = () => ({
    type: actionTypes.CONTRACT_METHOD_CANCEL_PROMOTIONAL_CODE
});

const promotionalCodeAcceptanceChecboxChecked = checked => ({
    type: actionTypes.CONTRACT_METHOD_VALIDATE_PROMOTIONAL_CODE_ACCEPTANCE_CHECKED,
    payload: {
        checked
    }
});

const requestJuniorAccountDataInProgress = () => ({
    type: actionTypes.OPENYOUNG_GET_JUNIOR_ACCOUNT_DATA_IN_PROGRESS
});

const requestJuniorAccountDataSuccess = (response, callback) => {
    callback(response);
    return {
        type: actionTypes.OPENYOUNG_GET_JUNIOR_ACCOUNT_DATA_SUCCESS,
        payload: {
            response
        }
    };
};

const requestJuniorAccountDataFailure = error => ({
    type: actionTypes.OPENYOUNG_GET_JUNIOR_ACCOUNT_DATA_FAILURE,
    payload: {
        error
    }
});

const depositLegalTextReset = () => ({
    type: actionTypes.DEPOSIT_LEGAL_TEXT_RESET
})

const depositLegalTextRequest = ({ depositIdentify, amount }) => ({
    type: actionTypes.DEPOSIT_LEGAL_TEXT_REQUEST,
    payload: {
        depositIdentify,
        amount
    }
})

const depositLegalTextSuccess = ({response, depositIdentify, amount}) => ({
    type: actionTypes.DEPOSIT_LEGAL_TEXT_SUCCESS,
    payload: {
        depositIdentify,
        amount,
        response,
    },
})

const depositLegalTextFailure = ({ depositIdentify, amount }) => ({
    type: actionTypes.DEPOSIT_LEGAL_TEXT_FAILURE,
    payload: {
        depositIdentify,
        amount
    }
})

const requestJuniorAccountData = (data, callback) => dispatch => {
    const requestData = {
        query: data
    };

    dispatch(requestJuniorAccountDataInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('openYoungJuniorAccountData'), requestData).then(
        response => {
            if (!!response.error || !!response.errorDescription) {
                dispatch(requestJuniorAccountDataFailure(response.error));
            } else {
                dispatch(requestJuniorAccountDataSuccess(response, callback));
            }
        },
        error => dispatch(requestJuniorAccountDataFailure(error.description))
    );
};

const requestAccountInterveners = (immAccount, callback) => (dispatch) => {
    return dispatch(accountIntervenersActions.requestAccountInterveners(immAccount.get('accountId')))
        .then(response => dispatch(callback && callback(immAccount, response.dato)))
        .catch(response => { throw response });
};

const requestGetCountriesSuccess = (countries) => ({
    type: actionTypes.REQUEST_GET_COUNTRIES_SUCCESS,
    payload: { countries }
})

const requestGetCountriesFailure = (error) => ({
    type: actionTypes.REQUEST_GET_COUNTRIES_FAILURE,
    payload: { error }
})

const requestGetCountriesInProgress = () => ({
    type: actionTypes.REQUEST_GET_COUNTRIES_IN_PROGRESS
});

const getCountries = () => (dispatch, getState) => {
    const immContracts = getState().contracts;

    const isFetching = immContracts.get('getCountriesIsFetching');

    const requestData = {
        query: {
            language: getLanguage()
        }
    };

    if (!isFetching) {
        dispatch(requestGetCountriesInProgress());
        return APIGet(dispatch, apiURLBuilder.getURL('getCountries'), requestData)
            .then(response => {
                return dispatch(requestGetCountriesSuccess(response));
            })
            .catch(response => {
                dispatch(requestGetCountriesFailure(response.error))
            }
            );
    }
}

const getProfessionCnaeUncategorizedIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNAE_UNCATEGORIZED_IS_FETCHING
});

const getProfessionCnaeCategoryIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNAE_CATEGORY_IS_FETCHING

});

const getProfessionCnaeCategoryItemIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNAE_CATEGORY_ITEM_IS_FETCHING
});

const getProfessionCnoSubcategoryPrivateIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNO_SUBCATEGORY_PRIVATE_IS_FETCHING
});

const getProfessionCnoPrivateItemIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNO_PRIVATE_ITEM_IS_FETCHING
});

const getProfessionCnoSubcategoryPublicIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNO_SUBCATEGORY_PUBLIC_IS_FETCHING
});

const getProfessionCnoPublicItemIsFetching = () => ({
    type: actionTypes.GET_PROFESSION_CNO_PUBLIC_ITEM_IS_FETCHING
});

const getSectorSubcategoriesIsFetching = () => ({
    type: actionTypes.GET_SECTOR_SUBCATEGORIES_IS_FETCHING
});

const getSectorItemIsFetching = () => ({
    type: actionTypes.GET_SECTOR_ITEM_IS_FETCHING
});

const getProfessionCnaeUncategorizedSuccess = items => ({
    type: actionTypes.GET_PROFESSION_CNAE_UNCATEGORIZED_SUCCESS,
    items
});

const getProfessionCnaeCategorySuccess = items => ({
    type: actionTypes.GET_PROFESSION_CNAE_CATEGORY_SUCCESS,
    items
});

const getProfessionCnaeCategoryItemSuccess = items => ({
    type: actionTypes.GET_PROFESSION_CNAE_CATEGORY_ITEM_SUCCESS,
    items
});

const getProfessionCnoSubcategoryPrivateSuccess = items => ({
    type: actionTypes.GET_PROFESSION_CNO_SUBCATEGORY_PRIVATE_SUCCESS,
    items
});

const getProfessionCnoPrivateItemSuccess = (items, prefix = '') => ({
    type: actionTypes.GET_PROFESSION_CNO_PRIVATE_ITEM_SUCCESS,
    prefix,
    items
});

const getProfessionCnoSubcategoryPublicSuccess = items => ({
    type: actionTypes.GET_PROFESSION_CNO_SUBCATEGORY_PUBLIC_SUCCESS,
    items
});

const getProfessionCnoPublicItemSuccess = (items, prefix = '') => ({
    type: actionTypes.GET_PROFESSION_CNO_PUBLIC_ITEM_SUCCESS,
    prefix,
    items
});

const getSectorSubcategoriesSuccess = items => ({
    type: actionTypes.GET_SECTOR_SUBCATEGORIES_SUCCESS,
    items
});

const getSectorItemSuccess = items => ({
    type: actionTypes.GET_SECTOR_ITEM_SUCCESS,
    items
});

const getProfessionSectorData = ({ endpoint, fetchingFunc, successFunc, params, queryParams, prefix }) => (dispatch) => {
    dispatch(fetchingFunc());
    return APIGet(dispatch, apiURLBuilder.getURL(endpoint, params), queryParams).then(
        response => dispatch(successFunc(response.items, prefix))
    );
}

const getProfessionCnaeUncategorized = () => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getProfessionCnaeUncategorized',
        fetchingFunc: getProfessionCnaeUncategorizedIsFetching,
        successFunc: getProfessionCnaeUncategorizedSuccess,
        queryParams: {
            query: {
                language: getLanguage()
            }
        }
    };
    return getProfessionSectorData(requestConfig);
};

const getProfessionCnaeCategory = () => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getProfessionCnaeCategory',
        fetchingFunc: getProfessionCnaeCategoryIsFetching,
        successFunc: getProfessionCnaeCategorySuccess,
        queryParams: {
            query: {
                language: getLanguage()
            }
        }
    };
    return getProfessionSectorData(requestConfig);
};

const getProfessionCnaeCategoryItem = categoryId => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getProfessionCnaeCategoryItem',
        fetchingFunc: getProfessionCnaeCategoryItemIsFetching,
        successFunc: getProfessionCnaeCategoryItemSuccess,
        params: {
            categoryId
        },
        queryParams: {
            query: {
                language: getLanguage()
            }
        }
    };
    return getProfessionSectorData(requestConfig);
};

const getProfessionCnoSubcategoryPrivate = () => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getProfessionCnoSubcategoryPrivate',
        fetchingFunc: getProfessionCnoSubcategoryPrivateIsFetching,
        successFunc: getProfessionCnoSubcategoryPrivateSuccess,
        queryParams: {
            query: {
                language: getLanguage()
            }
        }
    };
    return getProfessionSectorData(requestConfig);
};

const getProfessionCnoPrivateItem = (cnoId, prefix = '') => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getProfessionCnoPrivateItem',
        fetchingFunc: getProfessionCnoPrivateItemIsFetching,
        successFunc: getProfessionCnoPrivateItemSuccess,
        params: {
            cnoId
        },
        queryParams: {
            query: {
                language: getLanguage()
            }
        },
        prefix
    };
    return getProfessionSectorData(requestConfig);
};

const getProfessionCnoSubcategoryPublic = () => {
    const requestConfig = {
        fetchingField: 'professionCnoSubcategoryPublicIsFetching',
        endpoint: 'getProfessionCnoSubcategoryPublic',
        fetchingFunc: getProfessionCnoSubcategoryPublicIsFetching,
        successFunc: getProfessionCnoSubcategoryPublicSuccess,
    };
    return getProfessionSectorData(requestConfig);
};

const getProfessionCnoPublicItem = (prefix = '') => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getProfessionCnoPublicItem',
        fetchingFunc: getProfessionCnoPublicItemIsFetching,
        successFunc: getProfessionCnoPublicItemSuccess,
        prefix
    };
    return getProfessionSectorData(requestConfig);
};

const getSectorSubcategories = () => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getSectorSubcategories',
        fetchingFunc: getSectorSubcategoriesIsFetching,
        successFunc: getSectorSubcategoriesSuccess,
        queryParams: {
            query: {
                language: getLanguage()
            }
        }
    };
    return getProfessionSectorData(requestConfig);
};

const getSectorItem = (sectorId) => {
    const requestConfig = {
        fetchingField: '',
        endpoint: 'getSectorItem',
        fetchingFunc: getSectorItemIsFetching,
        successFunc: getSectorItemSuccess,
        params: {
            sectorId
        },
        queryParams: {
            query: {
                language: getLanguage()
            }
        }
    };
    return getProfessionSectorData(requestConfig);
};

const updateShouldShowUpgradeToPayrollPreStep = () => {
    return {
        type: actionTypes.UPDATE_SHOULD_SHOW_UPGRADE_TO_PAYROLL_PRE_STEP,
        payload: {
            shouldShowUpgradeToPayrollPreStep: false
        }
    };
}

const fiocStatusRequest = () => {
    return {
        type: actionTypes.FIOC_STATUS_REQUEST,
    };
};

const fiocStatusSuccess = (response) => {
    return {
        type: actionTypes.FIOC_STATUS_SUCCESS,
        payload: {
            response
        }
    };
};

const fiocStatusFailure = (error) => {
    return {
        type: actionTypes.FIOC_STATUS_FAILURE,
        payload: {
            error
        }
    };
};

const fiocUpdateSuccess = (response) => {
    return {
        type: actionTypes.FIOC_UPDATE_SUCCESS,
        payload: {
            response
        }
    };
};

const fiocUpdateFailure = (error) => {
    return {
        type: actionTypes.FIOC_UPDATE_FAILURE,
        payload: {
            error
        }
    };
};

const fiocUpdate = (query) => (dispatch, getState) => {
    const callback = (dispatch) => {
        return APIPost({
            dispatch,
            endpoint: 'fiocStatus',
            params: { query }
        })
            .then(response => {
                if (response.errors.length > 0) {
                    dispatch(fiocUpdateFailure(response));
                } else {
                    dispatch(getFiocStatus());
                    tagFiocPersonalInfoSuccess();
                    dispatch(fiocUpdateSuccess(response));
                }
            })
            .catch(error => dispatch(fiocUpdateFailure(error)));
    };
        
    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const fiocStatus = () => (dispatch) => {
    dispatch(fiocStatusRequest());
    const params = {
        header: {
             version: 2
        }
    }

    return APIGet({
        dispatch,
        endpoint: 'fiocFormStatus',
        params
    })
        .then(response => {
            if (response.errors) {
                dispatch(fiocStatusFailure(response));
            } else {
                dispatch(fiocStatusSuccess(response));
            }
        })
        .catch(error => dispatch(fiocStatusFailure(error)));
}

const getOpenYoungProfilesInProgress = () => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILES_FOR_CONTRACT_REQUEST
});

const getOpenYoungProfilesSuccess = response => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILES_FOR_CONTRACT_SUCCESS,
    payload: {
        profiles: response
    }
});

const getOpenYoungProfilesFailure = error => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILES_FOR_CONTRACT_FAILURE,
    payload: {
        error
    }
});

const getOpenYoungProfilesForContract = () => (dispatch) => {
    dispatch(getOpenYoungProfilesInProgress());
    dispatch(openYoungGetProfilesActions.getOpenYoungProfiles())
        .then(response => {
            if (!!response.error) {
                dispatch(getOpenYoungProfilesFailure(response.error.description));
            } else {
                dispatch(getOpenYoungProfilesSuccess(response));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getOpenYoungProfilesFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const requestJuniorProductDataRequest = () => ({
    type: actionTypes.OPEN_YOUNG_GET_JUNIOR_PRODUCT_DATA_FOR_CONTRACT_IS_FETCHING
});

const requestJuniorProductDataSuccess = (data) => ({
    type: actionTypes.OPEN_YOUNG_GET_JUNIOR_PRODUCT_DATA_FOR_CONTRACT_SUCCESS,
    payload: data
});

const requestJuniorProductDataFailure = (error) => ({
    type: actionTypes.OPEN_YOUNG_GET_JUNIOR_PRODUCT_DATA_FOR_CONTRACT_FAILURE,
    payload: {
        error
    }
});

const requestJuniorProductData = (data) => (dispatch) => {
    const notificationMsg = formatText('contractsView-contractsView_OYAccountNotificationMessage');
    const params = {
        header: {
            version: 1
        },
        query: {
            childNifNumber: data,
        }
    };

    dispatch(requestJuniorProductDataRequest());
    return APIPost({
        dispatch,
        endpoint: 'openYoungGetJuniorProductData',
        params
    })
        .then(response => {
            dispatch(requestJuniorProductDataSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestJuniorProductDataFailure(response.error));
                dispatch(notification.error({ message: notificationMsg }))
            } else {
                throw response;
            }
        });
};

const getOpenYoungProfileDetailsFailure = error => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_FOR_CONTRACT_FAILURE,
    payload: {
        error
    }
});

const getOpenYoungProfileDetailsSuccess = response => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_FOR_CONTRACT_SUCCESS,
    payload: {
        profileData: response
    }
});

const getOpenYoungProfileDetailsInProgress = () => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_FOR_CONTRACT_REQUEST
});

const getOpenYoungProfileDetailsForContract = id => (dispatch, getState) => {
    const immOpenYoungProfiles = getState().openYoungProfiles;
    const immProfile = immOpenYoungProfiles.get('byId').find(immProfile => {
        return `${immProfile.get('personCode')}` === id;
    });
    dispatch(getOpenYoungProfileDetailsInProgress());
    dispatch(openYoungGetProfileDetailsActions.getOpenYoungProfileDetails(immProfile.get('id')))
        .then(response => {
            if (!!response.error) {
                dispatch(getOpenYoungProfileDetailsFailure(response.error.description));
            } else {
                dispatch(getOpenYoungProfileDetailsSuccess(response));
                const childDocumentDetails = response.documentoIdentificacion;
                if (childDocumentDetails && childDocumentDetails.codigodocumpersonacorp)
                    dispatch(requestJuniorProductData(trim(childDocumentDetails.codigodocumpersonacorp)));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getOpenYoungProfileDetailsFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const toggleAgree = () => ({
    type: actionTypes.CONTRACT_METHOD_TOGGLE_AGREE
});

const onDownloadDocumentRequest = () => ({
    type: actionTypes.CONTRACT_METHOD_DOWNLOAD_DOCUMENT
});

const onDownloadDocumentSuccess = (payload) => ({
    type: actionTypes.CONTRACT_METHOD_DOWNLOAD_DOCUMENT_SUCCESS,
    payload
});

const onDownloadDocumentError = (payload) => ({
    type: actionTypes.CONTRACT_METHOD_DOWNLOAD_DOCUMENT_ERROR,
    payload
});

const onDownloadDocument = () => (dispatch, getState) => {
    const immContracts = getState().contracts;

    const isFetchingZip = immContracts.getIn(['document', 'isFetchingZip']);

    if (!isFetchingZip) {
        const params = {
            header: {
                responseType: 'arraybuffer'
            }
        };

        dispatch(onDownloadDocumentRequest());
        APIGet({ dispatch, endpoint: 'pregrantedCreditHiringDocumentsZip', params })
            .then(response => {
                dispatch(onDownloadDocumentSuccess());
                download(response.xhr.response, 'DocumentosProteccionDescubierto.zip', 'application/pdf');
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(onDownloadDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const onPrintDocument = () => (dispatch, getState) => {
    const immContracts = getState().contracts;
    const documents = immContracts.getIn(['document', 'file']);
    const data = [new Uint8Array(documents)];

    const blobObject = new Blob(data, { type: 'application/pdf' });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(blobObject);
    } else {
        const blobURL = window.URL.createObjectURL(blobObject);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const resetDocumentsAndAgreeCheckBox = () => ({
    type: actionTypes.CONTRACT_METHOD_RESET_DOCUMENTS_AGREE
});

const getHiringDocumentsRequest = () => ({
    type: actionTypes.CONTRACT_METHOD_GET_HIRING_DOCUMENTS
});

const getHiringDocumentsSuccess = (payload) => ({
    type: actionTypes.CONTRACT_METHOD_GET_HIRING_DOCUMENTS_SUCCESS,
    payload
});

const getHiringDocumentsError = (payload) => ({
    type: actionTypes.CONTRACT_METHOD_GET_HIRING_DOCUMENTS_ERROR,
    payload
});

const getHiringDocuments = () => (dispatch, getState) => {
    const immContracts = getState().contracts;

    if (!!immContracts.getIn(['document', 'file'])) {
        return;
    }

    const params = {
        header: {
            responseType: 'arraybuffer'
        }
    };

    dispatch(getHiringDocumentsRequest());
    APIGet({ dispatch, endpoint: 'pregrantedCreditHiringDocuments', params })
        .then(response => {
            dispatch(getHiringDocumentsSuccess({ response: response.xhr.response }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getHiringDocumentsError({ error: response.error }));
            } else {
                throw response;
            }
    });
};

const getPreContractualsDocumentURL = ({fromRenewalOrTransferToken}) => (dispatch)=>{
    const params = {
        query: {
            metadata: {
                depositIdentify: fromRenewalOrTransferToken
             },
            precontractualType: "DEPOSIT"
        }
    };
    APIPost({ dispatch, endpoint: 'requestPreContractualsGenerateURL', params })
        .then(response => {
            dispatch(setPrecontractualDocumentUrl( response.generatedDocumentUrl ));
        })
        .catch( () => {
                dispatch(getPrecontractualsDocumentURLFailure());
    });
}

const getPreContractualsDocumentId = (identifier, name = '') => (dispatch, getState)=>{
    const formattedName = name ? 
        formatText(name) : 
        formatText(`${getState().contracts.getIn(['mainDeposits', 'data', 'context'])}-${getState().contracts.getIn(['mainDeposits', 'data', 'name'])}`);
    const params = {
        query: {
            metadata: {
                depositIdentify: identifier,
                termPeriod: formatText('contractsView-months'),
                productType: formattedName
             },
            precontractualType: "DEPOSIT_RENEWAL"
        }
    };
    APIPost({ dispatch, endpoint: 'requestPreContractualsGenerateURL', params })
        .then(response => {
            dispatch(setPrecontractualDocumentId( response.dmsDocumentId ));
        })
        .catch( () => {
                dispatch(getPrecontractualsDocumentIdFailure());
    });
}

const getPrecontractualDocumentURLOrID = (options) => (dispatch) => {
    const {payload, onDocumentURLCallback, onDocumentIDCallback} = options;
    const params = {
        query: payload
    };

    dispatch(getPrecontractualDocumentURLOrIDRequest());
    APIPost({ dispatch, endpoint: 'requestPreContractualsGenerateURL', params })
        .then(response => {
            if(response.generatedDocumentUrl !== undefined && response.generatedDocumentUrl !== ''){
                dispatch(setPrecontractualDocumentUrl( response.generatedDocumentUrl ));
                onDocumentURLCallback && onDocumentURLCallback(response.generatedDocumentUrl)
            } else if ( response.dmsDocumentId !== undefined && response.dmsDocumentId !== ''){
                dispatch(setPrecontractualDocumentId( response.dmsDocumentId ));
                onDocumentIDCallback && onDocumentIDCallback(response.dmsDocumentId)
            }
        })
        .catch( () => {
                dispatch(getPrecontractualsDocumentURLFailure());
    });
}

const setAllAccountsToInactive = () => ({
    type: actionTypes.CONTRACT_HIRE_SET_ALL_ACCOUNTS_TO_INACTIVE
});

const requestDepositsInterest = ({ rate, months, amount } = {}) => (dispatch, getState) => {
    const isFetchingInterest = getState().contracts.getIn(['interest', 'isFetching']);
    if (isFetchingInterest) return

    dispatch(depositInterestFetching());
    const requestData = {
        query: {
            rate,
            months,
            amount
        }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('depositsInterest'), requestData).then(
        (response) => {
            dispatch(depositInterestSuccess(response))
        },
        (error) => {
            dispatch(depositInterestFailure(error))
        }
    );
};

const getDepositLegalTextFormatteddValue = ({ depositIdentify, amount, depositId }) => (dispatch, getState) => {
    depositLegalTextRequest({ depositIdentify, amount })

    const expirationDate = depositId ? getState().deposits.getIn(['byId', depositId, 'impositionList', 'byId']).first().get('expirationDate') : null;


    const userName = getState().profile.get('nombreCompleto');
    const originCountry = getState().profile.get('originCountry');

    const legalTextRequestData = {
        query: {
            language: getLanguage(),
            depositIdentify,
            amount,
            userName,
            expirationDate: expirationDate ? DateHelper.buildFormattedDate(expirationDate, DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_WITH_SLASHES) : undefined
        }
    }

    return APIPost(dispatch, apiURLBuilder.getURL('depositLegalText'), legalTextRequestData)
        .then(response =>
            dispatch(depositLegalTextSuccess({ response, depositIdentify, amount })),
        )
        .catch(response => {
            dispatch(depositLegalTextFailure({ depositIdentify, amount }));
        });
}

module.exports = {
    addIntervener,
    addSimpleIntervener,
    cancelPromotionalCode,
    changeIntervenerRelationship,
    clearInterveners,
    closeModal,
    deleteAdditionalCountry,
    depositLegalTextReset,
    excludeIntervener,
    fiocUpdate,
    fiocStatus,
    getContractInformation,
    getContractInformationWithPricing,
    getCountries,
    getDepositLegalTextFormatteddValue,
    getHiringDocuments,
    getOpenYoungProfileDetailsForContract,
    getOpenYoungProfilesForContract,
    getProfessionCnae,
    getProfessionCnaeCategory,
    getProfessionCnaeCategoryItem,
    getProfessionCnaeUncategorized,
    getProfessionCno,
    getprofessionCnoPrivate,
    getProfessionCnoPrivateItem,
    getProfessionCnoPublicItem,
    getProfessionCnoSubcategoryPrivate,
    getProfessionCnoSubcategoryPublic,
    getPreContractualsDocumentId,
    getPrecontractualDocumentURLOrID,
    getSectorItem,
    getSectorSubcategories,
    hire,
    hireContractFailure,
    hireContractNewAccount,
    hireContractSuccess,
    isServiceCalled,
    loadState,
    onDownloadDocument,
    onPrintDocument,
    postChange,
    promotionalCodeAcceptanceChecboxChecked,
    promotionalCodeSetDirty,
    removeIntervener,
    requestAccountInterveners,
    requestAccounts,
    requestAccountsSpecial,
    requestDepositsInterest,
    requestIntervenersSpecial,
    requestJuniorProductData,
    requestJuniorAccountData,
    requestReferenceStandard,
    requestValidatePromotionalCode,
    reset,
    resetDocumentsAndAgreeCheckBox,
    restoreDefaultInterveners,
    setAllAccountsToInactive,
    setCardImage,
    setContract,
    setDepositPolled,
    setInProgress,
    setIntervenerType,
    setPayrollAccountPromoCode,
    setPrecontractualDocumentId,
    setRenewalAccountBlocked,
    setRenewalDepositId,
    setImpositionAmount,
    setRenewalOrTransferToken,
    setVisibleStep,
    setWillCancel,
    toggleAgree,
    toNextStep,
    updateAccounts,
    updateCardDetails,
    updateConditionDocumentConfirmation,
    updateConfirmationCheckboxes,
    updateDepositProduct,
    updateSimpleIntervener,
    updateShouldShowUpgradeToPayrollPreStep,
    upgradeToPayrollAccount,
    validateStep,
    toggleInfoModal,
    getPreContractualsDocumentURL,
    setPrecontractualDocumentUrl,
    setMaxImportAmount
};